import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { Component } from 'react'
import CopyableInput from 'shared/components/inputs/copyable'
import css from './list-item-footer.css'

const Link = ({ url, hide, onClose, isMobile }) => {
    return (
        <div className={hide ? css.copyLinkHide : css.copyLink}>
            <CopyableInput
                value={url}
                className={isMobile ? css.copyLinkInput : css.copyLinkInputDesktop}
                onCopy={() => global.showSuccess && global.showSuccess('Copied to clipboard!')}
            />
            <i className={css.closeLink} onClick={onClose} />
        </div>
    )
}

export default class Footer extends Component {
    state = {
        inputContent: '',
    }
    toggleLink(toggleState) {
        this.setState({
            inputContent: toggleState,
        })
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.gif !== this.props.gif) {
            return true
        }
        if (nextState.inputContent !== this.state.inputContent) {
            return true
        }
        return false
    }
    render() {
        const {
            gif,
            mobileFb,
            isMobile,
            items = ['facebook', 'twitter', 'pinterest', 'link'],
            getSocialUrls,
            getEmbed,
            socialClick,
        } = this.props
        const { inputContent } = this.state
        const { twitter, pinterest, facebook } = getSocialUrls(gif, isMobile)
        const buttonProps = {
            facebook: { onClick: () => socialClick(facebook, mobileFb, gif) },
            twitter: { onClick: () => socialClick(twitter) },
            pinterest: { onClick: () => socialClick(pinterest) },
            link: { onClick: () => this.toggleLink(gif.url) },
            embed: { onClick: () => this.toggleLink(getEmbed(gif)) },
        }

        return (
            <div className={css.container}>
                <div className={inputContent ? css.buttonContainerHide : css.buttonContainer}>
                    {items.map((socialItem, index) => {
                        const { onClick } = buttonProps[socialItem]
                        return <a className={css[socialItem]} onClick={onClick} target="_blank" key={index} />
                    })}
                </div>
                <Link url={this.state.inputContent} hide={!inputContent} onClose={() => this.toggleLink(false)} />
            </div>
        )
    }
}
